export default {
  forgotPasswordSuccess: 'Reset password request submitted. Check your email for further instructions.',
  routeNumberWarning: 'Please ensure you have the right ACH routing number from your financial documents. Click here to see the list of commonly used routing number across states.',
  routingNumberModalHeading: 'ACH Routing Numbers',
  routingNumberModalMessage: 'List of commonly used routing numbers across states',
  routingNumberModalTableBankAcct: 'Bank Account State',
  routingNumberModalTableRoutingNo: 'ACH Routing No.',
};
